var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Typography from '../Typography';
import styled from 'styled-components';
import { colors } from '../../../theme/colors';
var FontSizeByLevel = [0, 40, 32, 28, 24, 20];
var LineHeightByLevel = [0, 52, 44, 40, 32, 28];
var Title = styled(Typography.Title)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 600;\n    line-height: ", ";\n    color: ", ";\n  }\n"], ["\n  && {\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 600;\n    line-height: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var _b = _a.level, level = _b === void 0 ? 4 : _b;
    return FontSizeByLevel[level] + "px";
}, function (_a) {
    var _b = _a.level, level = _b === void 0 ? 4 : _b;
    return LineHeightByLevel[level] + "px";
}, colors.title);
export default Title;
var templateObject_1;
//# sourceMappingURL=Title.js.map